import Button from "@covertree/ui/buttons/Button";
import Box from "@mui/material/Box";
interface Props {
  loading?: boolean;
  disabled?: boolean;
  width?: number;
  onCancel: () => void;
}

export const CancelButton = ({
  onCancel,
  loading = false,
  disabled = false,
  width,
}: Props) => {
  return (
    <Box mt={4} width={width ?? "100%"}>
      <Button
        fullWidth
        loading={loading}
        disabled={disabled}
        onClick={onCancel}
        variant="outlined">
        Cancel
      </Button>
    </Box>
  );
};

export default CancelButton;
